import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const AddCategory = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    image: null,
    status: true,
  });

  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (ev) => {
    const file = ev.target.files[0];
    setFormData((prev) => ({ ...prev, image: file }));
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("name", formData.name);
    form.append("description", formData.description);
    form.append("status", formData.status);
    form.append("image", formData.image);

    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        "https://ecom-api.applligentdemo.com/category/createCategory",
        form,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Category Save");
        navigate("/category");
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error("Error while submitting:", error);
      toast.error(" Submission failed. Check network or server.");
    }
  };

  return (
    <Container className="mt-5">
      <Button variant="secondary" onClick={() => navigate(-1)}>
        ← Back
      </Button>
      <h2 className="mb-4">Add New Category</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="name" className="mb-3">
          <Form.Label>Category Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="description" className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="status" className="mb-3">
          <Form.Label>Status</Form.Label>
          <Form.Select
            name="status"
            value={formData.status ? "Active" : "Inactive"} // Convert boolean to string
            onChange={
              (e) =>
                setFormData({
                  ...formData,
                  status: e.target.value === "Active",
                }) // Convert string to boolean
            }
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="image" className="mb-3">
          <Form.Label>Image</Form.Label>
          <Form.Control
            type="file"
            onChange={handleImageChange}
            accept="image/*"
          />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                marginTop: "10px",
                width: "60px",
                height: "60px",
                objectFit: "cover",
              }}
            />
          )}
        </Form.Group>

        <Button type="submit" variant="success">
          Save Category
        </Button>
      </Form>
    </Container>
  );
};

export default AddCategory;
